export default __webpack_public_path__ + "static/media/overlord.df6520bd.png";